import { render } from "./dashbordpage.vue?vue&type=template&id=8d27aef2&scoped=true"
import script from "./dashbordpage.vue?vue&type=script&lang=js"
export * from "./dashbordpage.vue?vue&type=script&lang=js"

import "./dashbordpage.vue?vue&type=style&index=0&id=8d27aef2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d27aef2"]])

export default __exports__